import type { DefineComponent } from 'vue';

import {
  type KaVeeFormGroupProps,
  veeFormFieldHOC,
} from '@/kasten-components/components/KaVeeFormField';

import KaInputNumber from './KaInputNumber.vue';
import type { KaInputNumberProps } from './types';

export type { KaInputNumberBaseProps, KaInputNumberProps } from './types';

const KaInputNumberVee = veeFormFieldHOC(
  KaInputNumber as unknown as DefineComponent<KaInputNumberProps>,
) as unknown as DefineComponent<KaInputNumberProps & KaVeeFormGroupProps>; // currently it's not possible to pass component with generic, checkout ./src/components/KaVeeFormField/README.md:L12

export { KaInputNumber, KaInputNumberVee };
